export function handleKey() {
  let t = new Date()
  t = Math.random() * t.getTime()
  return t
}
